(() => {
  // ---- Prices come from the tier buttons, which Liquid renders from the pricing block at the top of index.liquid ----
  const tierButtons = [...document.querySelectorAll('.tier')];
  const PACKS = Object.fromEntries(tierButtons.map(b => [Number(b.dataset.qty), Number(b.dataset.price)]));
  const SINGLE = PACKS[1] || 1999;
  const pricing = JSON.parse(document.getElementById('taply-pricing').textContent);
  const EXTRA = pricing.extra;
  const FREE_SHIP = pricing.freeShipping;
  const TOP = Math.max(...Object.keys(PACKS).map(Number));
  const money = cents => `$${(cents / 100).toFixed(2)}`;

  // ---- Shopify variant IDs (unchanged from the previous theme) ----
  const variantMap = {
    'Google Review Sticky Plate': {1: 48263205322978, 10: 48263205355746, 2: 48263205388514, 3: 48263205421282, 4: 48263205454050, 5: 48263205486818, extra: 48263557349602},
    'Google Review Stand - White': {1: 48263205519586, 10: 48263205552354, 2: 48263205585122, 3: 48263205617890, 4: 48263205650658, 5: 48263205683426, extra: 48263557382370},
    'Google Review Stand - Black': {1: 48263205716194, 10: 48263205748962, 2: 48263205781730, 3: 48263205814498, 4: 48263205847266, 5: 48263205880034, extra: 48263557415138},
    'Mixed Variety Bundle': {1: 48263974715618, 2: 48263974748386, 3: 48263974781154, 4: 48263974813922, 5: 48263974846690, 10: 48263974879458, extra: 48263974912226}
  };

  // ---- State ----
  const styleMix = {black: 1, white: 0, sticky: 0};
  const styleLabels = {black: 'Black Stand', white: 'White Stand', sticky: 'Sticky Plate'};
  let packQty = 1, extras = 0, primary = 'black';
  const totalQty = () => packQty + extras;
  const totalPrice = () => PACKS[packQty] + extras * EXTRA;
  const mixTotal = () => Object.values(styleMix).reduce((a, b) => a + b, 0);
  const mixSummary = () => Object.entries(styleMix).filter(([, v]) => v > 0).map(([k, v]) => `${v} ${styleLabels[k]}${v > 1 ? 's' : ''}`).join(' · ');

  // ---- Elements ----
  const $ = s => document.querySelector(s);
  const add = $('#addBtn'), mixStatus = $('#mixStatus'), hint = $('#allocationHint'), listing = $('#listing');
  const rows = [...document.querySelectorAll('.style-row')];
  const extraPanel = $('#extraPanel'), extraOut = $('#extraQty');
  const upsell = $('#upsell'), upsellText = $('#upsellText'), upsellBtn = $('#upsellBtn');
  const hero = $('#heroImg'), heroTag = $('#heroTag');
  const thumbs = [...document.querySelectorAll('.thumb')];

  // ---- Gallery ----
  const showThumb = i => { const t = thumbs[i]; if (!t) return; thumbs.forEach(x => x.classList.remove('active')); t.classList.add('active'); hero.src = t.dataset.img; hero.alt = t.querySelector('img')?.alt || t.getAttribute('aria-label') || ''; heroTag.textContent = t.dataset.tag; };
  thumbs.forEach((t, i) => t.addEventListener('click', () => showThumb(i)));
  const galleryByKey = {black: 0, white: 1, sticky: 2};
  const shot = $('.mainshot'); let startX = null;
  shot?.addEventListener('pointerdown', e => { startX = e.clientX; });
  shot?.addEventListener('pointerup', e => { if (startX === null) return; const d = e.clientX - startX; startX = null; if (Math.abs(d) > 45) { const cur = Math.max(thumbs.findIndex(t => t.classList.contains('active')), 0); showThumb((cur + (d < 0 ? 1 : -1) + thumbs.length) % thumbs.length); } });
  shot?.addEventListener('pointercancel', () => { startX = null; });

  // ---- Fit the style mix to the pack size, keeping what the customer already picked ----
  function fitMix() {
    const target = totalQty();
    let diff = target - mixTotal();
    if (diff > 0) { styleMix[primary] += diff; return; }
    const order = Object.keys(styleMix).filter(k => k !== primary).concat(primary);
    for (const k of order) { while (diff < 0 && styleMix[k] > 0) { styleMix[k]--; diff++; } }
  }

  function render() {
    const qty = totalQty(), price = totalPrice(), compare = SINGLE * qty, save = compare - price, allocated = mixTotal(), ready = allocated === qty;
    // tiers
    tierButtons.forEach(b => b.setAttribute('aria-checked', String(Number(b.dataset.qty) === packQty)));
    extraPanel.hidden = packQty !== TOP;
    extraOut.textContent = extras;
    $('#extraMinus').disabled = extras === 0;
    // styles
    rows.forEach(r => { const v = styleMix[r.dataset.key]; r.querySelector('.mix-count').textContent = v; r.classList.toggle('active', v > 0); r.querySelector('.mix-minus').disabled = v === 0; });
    mixStatus.classList.toggle('ready', ready);
    mixStatus.innerHTML = ready ? `<span>All set</span><b>${allocated} of ${qty} chosen</b>` : `<span>Choose ${qty - allocated} more style${qty - allocated > 1 ? 's' : ''}</span><b>${allocated} of ${qty} chosen</b>`;
    $('#mixHint').textContent = qty > 1 ? 'Mix & match freely' : 'Tap a style to switch';
    // summary
    $('#sumLabel').textContent = `${qty} Taply${qty > 1 ? 's' : ''}${save > 0 ? ' at single price' : ''}`;
    $('#sumCompare').textContent = money(compare);
    $('#sumSaveRow').hidden = save <= 0;
    $('#sumSave').textContent = `−${money(save)}`;
    $('#sumShip').textContent = price >= FREE_SHIP ? 'Free' : `Free over ${money(FREE_SHIP)}`;
    $('#sumTotal').textContent = money(price);
    // CTA
    add.disabled = !ready;
    add.textContent = ready ? `Add to cart · ${money(price)}` : `Choose ${qty - allocated} more style${qty - allocated > 1 ? 's' : ''}`;
    hint.textContent = ready ? `${mixSummary()} · ships programmed and ready to tap` : 'Use + / − above to finish your mix.';
    // upsell: next pack up
    const sizes = Object.keys(PACKS).map(Number).sort((a, b) => a - b);
    const next = sizes.find(s => s > packQty);
    if (next && extras === 0) {
      const extraCost = PACKS[next] - PACKS[packQty];
      const nextSave = Math.round((1 - PACKS[next] / (SINGLE * next)) * 100);
      const unlocksShip = price < FREE_SHIP && PACKS[next] >= FREE_SHIP;
      upsellText.textContent = `Add ${next - packQty} more for just ${money(extraCost)}${unlocksShip ? ' + free shipping' : ` and save ${nextSave}%`}`;
      upsellBtn.textContent = `Make it ${next}`;
      upsell.dataset.next = next;
      upsell.hidden = false;
    } else upsell.hidden = true;
    // mobile bar
    $('#barTitle').textContent = `${qty} Taply${qty > 1 ? 's' : ''} · ${money(price)}`;
    $('#barSub').textContent = save > 0 ? `You save ${money(save)} · No monthly fee` : 'No app · No monthly fee';
  }

  function selectPack(q, opts = {}) {
    if (!PACKS[q]) return;
    packQty = q;
    if (q !== TOP) extras = 0;
    fitMix();
    render();
    if (opts.scroll) document.querySelector('#shop').scrollIntoView({behavior: 'smooth', block: 'start'});
  }

  tierButtons.forEach(b => b.addEventListener('click', () => selectPack(Number(b.dataset.qty))));
  // Arrow keys move between tiers (radio group behaviour)
  document.querySelector('.tiers')?.addEventListener('keydown', e => {
    const i = tierButtons.findIndex(b => b.getAttribute('aria-checked') === 'true');
    const step = {ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1}[e.key];
    if (step === undefined || i < 0) return;
    e.preventDefault();
    const n = tierButtons[(i + step + tierButtons.length) % tierButtons.length];
    selectPack(Number(n.dataset.qty)); n.focus();
  });
  document.querySelectorAll('[data-pick]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); selectPack(Number(a.dataset.pick), {scroll: true}); }));
  upsell.addEventListener('click', () => selectPack(Number(upsell.dataset.next)));

  $('#extraPlus').addEventListener('click', () => { extras++; fitMix(); render(); });
  $('#extraMinus').addEventListener('click', () => { if (extras > 0) { extras--; fitMix(); render(); } });

  rows.forEach(row => {
    const key = row.dataset.key;
    row.querySelector('.style-pick').addEventListener('click', () => {
      showThumb(galleryByKey[key]);
      if (totalQty() === 1 || mixTotal() === 0) { Object.keys(styleMix).forEach(k => styleMix[k] = 0); styleMix[key] = totalQty(); primary = key; render(); }
    });
    row.querySelector('.mix-plus').addEventListener('click', () => {
      showThumb(galleryByKey[key]);
      if (mixTotal() >= totalQty()) {
        // Pack is full: borrow one from the style with the most units so the customer is never blocked
        const donor = Object.keys(styleMix).filter(k => k !== key && styleMix[k] > 0).sort((a, b) => styleMix[b] - styleMix[a])[0];
        if (!donor) return;
        styleMix[donor]--;
      }
      styleMix[key]++; primary = key; render();
    });
    row.querySelector('.mix-minus').addEventListener('click', () => { if (styleMix[key] > 0) { styleMix[key]--; render(); } });
  });

  document.querySelectorAll('.card[data-select]').forEach(card => card.addEventListener('click', () => {
    const key = card.dataset.select;
    Object.keys(styleMix).forEach(k => styleMix[k] = 0);
    styleMix[key] = totalQty(); primary = key;
    showThumb(galleryByKey[key]); render();
    document.querySelector('#shop').scrollIntoView({behavior: 'smooth', block: 'start'});
  }));

  // ---- Cart ----
  const countNode = $('#cartCount');
  const mixedVariants = variantMap['Mixed Variety Bundle'];
  const styleCount = props => ['Black Stand', 'White Stand', 'Sticky Plate'].filter(n => String(props?.['Style Mix'] || '').includes(n)).length;
  async function migrateMixedCart(cart) {
    const changes = cart.items.flatMap(item => {
      if (styleCount(item.properties) < 2 || String(item.variant_title).startsWith('Mixed Variety Bundle')) return [];
      const isExtra = String(item.variant_title).includes('Extra Taply');
      const pack = isExtra ? 'extra' : Math.min(Number(String(item.variant_title).match(/\/\s*(\d+)/)?.[1] || String(item.properties?.['Part of bundle'] || '').match(/\d+/)?.[0] || 1), 10);
      const target = mixedVariants[pack];
      return target ? [{item, target}] : [];
    });
    if (!changes.length) return cart;
    for (const {item} of changes) await fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({id: item.key, quantity: 0})});
    await fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: changes.map(({item, target}) => ({id: target, quantity: item.quantity, properties: item.properties}))})});
    return fetch('/cart.js').then(r => r.json());
  }
  const carrierProduct = () => { const picked = rows.filter(r => styleMix[r.dataset.key] > 0); return picked.length > 1 ? 'Mixed Variety Bundle' : picked[0]?.dataset.product || 'Google Review Stand - Black'; };

  add.addEventListener('click', async () => {
    if (mixTotal() !== totalQty()) { render(); return; }
    const product = carrierProduct(), map = variantMap[product], variantId = map?.[packQty];
    if (!variantId || (extras > 0 && !map.extra)) return;
    const business = listing.value.trim();
    const isReviewLink = /^https?:\/\//i.test(business);
    const properties = {
      'Style Mix': mixSummary(),
      'Google Business Review Link': isReviewLink ? business : business ? 'Business lookup requested' : 'Customer will email after checkout',
      ...(business && !isReviewLink ? {'Business name': business} : {}),
      ...($('#businessCity').value.trim() ? {'Business city': $('#businessCity').value.trim()} : {}),
      ...($('#businessPostal').value.trim() ? {'Business ZIP / postal code': $('#businessPostal').value.trim()} : {})
    };
    add.disabled = true; add.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: [
        {id: variantId, quantity: 1, properties},
        ...(extras > 0 ? [{id: map.extra, quantity: extras, properties: {...properties, 'Part of bundle': `${totalQty()} Taplys`}}] : [])
      ]})});
      if (!res.ok) throw new Error('add failed');
      location.href = '/cart';
    } catch (err) {
      add.textContent = 'Something went wrong — try again';
      setTimeout(() => { add.disabled = false; render(); }, 1800);
    }
  });

  fetch('/cart.js').then(r => r.json()).then(migrateMixedCart).then(cart => { countNode.textContent = cart.item_count; }).catch(() => {});

  // ---- Mobile buy bar: hide while the buy box is on screen ----
  const bar = $('#mobileBuybar'), buyBox = $('.buy');
  if (bar && buyBox) {
    const heroCtas = document.querySelector('.hero-ctas');
    let heroPassed = !heroCtas, buyVisible = false;
    const visibility = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.target === heroCtas) heroPassed = entry.boundingClientRect.bottom <= 0;
        if (entry.target === buyBox) buyVisible = entry.isIntersecting;
      }
      bar.classList.toggle('is-hidden', !heroPassed || buyVisible);
    });
    if (heroCtas) visibility.observe(heroCtas);
    visibility.observe(buyBox);
  }

  // ---- Express checkout hook (unchanged API) ----
  window.connectTaplyPayments = function (adapter) {
    if (!adapter || !adapter.connected) return;
    const label = adapter.defaultPaymentLabel || 'Buy with Shop';
    const payload = () => ({product: carrierProduct(), qty: totalQty(), price: totalPrice() / 100, mix: {...styleMix}});
    document.querySelectorAll('.express-slot').forEach(slot => {
      slot.hidden = false;
      slot.innerHTML = `<button class="express-pay" type="button"></button><button class="more-payments" type="button">More payment options</button>`;
      slot.querySelector('.express-pay').textContent = label;
      slot.querySelector('.express-pay').onclick = () => adapter.checkoutDefault?.(payload());
      slot.querySelector('.more-payments').onclick = () => adapter.openPaymentOptions?.(payload());
    });
  };
  if (window.TaplyPayments?.connected) window.connectTaplyPayments(window.TaplyPayments);

  render();
})();
